import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TrainingCategoryModel } from '../../../models/training-category.model';
import { UserModel } from '../../../models/user.model';
import { getUserFullName } from '../../../utils/user.utils';

@Component({
  selector: 'app-lecturer-card',
  templateUrl: './lecturer-card.component.html',
  styleUrl: './lecturer-card.component.scss',
  standalone: false,
})
export class LecturerCardComponent {
  @Input() lecturer: UserModel;
  @Input() category: TrainingCategoryModel = {
    id: 0,
    name: 'Allgemein',
    descriptionBold: '',
    description: '',
    color50: '#0E332E',
    color0: '#0E332E',
    color70: '#BBD1CE',
    color80: '#E8F0EF',
    color90: '#E8F0EF',
    isDisabled: false,
  };

  public getUserFullName = getUserFullName;

  constructor(private router: Router) {}

  public viewLecturerVita(): void {
    this.router.navigate(['/lecturer-vita', btoa(this.lecturer.id.toString())]);
  }

  public viewLecturerSeminars(): void {
    this.router.navigate([
      '/lecturer-seminars',
      btoa(this.lecturer.id.toString()),
    ]);
  }
}
